export const BITSWAP_120 = '/ipfs/bitswap/1.2.0'
export const DEFAULT_MAX_SIZE_REPLACE_HAS_WITH_BLOCK = 1024
export const DEFAULT_MAX_INBOUND_STREAMS = 1024
export const DEFAULT_MAX_OUTBOUND_STREAMS = 1024
export const DEFAULT_MESSAGE_RECEIVE_TIMEOUT = 10_000
export const DEFAULT_WANTLIST_SEND_DEBOUNCE = 10
export const DEFAULT_MESSAGE_SEND_TIMEOUT = 10_000
export const DEFAULT_MESSAGE_SEND_CONCURRENCY = 50
export const DEFAULT_RUN_ON_TRANSIENT_CONNECTIONS = false
export const DEFAULT_SESSION_ROOT_PRIORITY = 1
export const DEFAULT_MAX_PROVIDERS_PER_REQUEST = 3
export const DEFAULT_MAX_OUTGOING_MESSAGE_SIZE = 1024 * 1024 * 4
export const DEFAULT_MAX_INCOMING_MESSAGE_SIZE = DEFAULT_MAX_OUTGOING_MESSAGE_SIZE
export const DEFAULT_DO_NOT_RESEND_BLOCK_WINDOW = 1_000 * 5
export const DEFAULT_MAX_WANTLIST_SIZE = 1024
